import projection from '../generated/pwp211f1.json';
import { AcceptanceManifest } from '../types';

/** Generated by scripts/build-acceptance-projections.js from the canonical Contract. */
export const pwp211f1AcceptanceManifest = projection as AcceptanceManifest;
